let exchangeRates = {
  USD: 1.16265,
  AUD: 1.624304,
  CAD: 1.516776,
  GBP: 0.889811,
  JPY: 130.253439
}

export function convertCurrency (amount, to) {
  return amount * exchangeRates[to]
}
